// src/utils.ts
var isTruthy = (l) => !!l;
var keepTruthy = (arr) => arr.filter(isTruthy);

export {
  isTruthy,
  keepTruthy
};
//# sourceMappingURL=chunk-YDAKBU6Q.js.map